export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f6c5db4ddcf987bee81824e5ba3d449397e4a60a0&name=fetchTypeahead!'